import { Component, forwardRef, Renderer2, ViewChild, Input, OnInit, OnChanges,Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DiagnosticService } from '../../service/diagnostic/diagnostic.service';

export const EPANDED_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AutocompleteDiagnosticComponent),
  multi: true,
};

@Component({
    selector: 'app-autocomplete-diagnostic',
    templateUrl: './autocomplete-diagnostic.component.html',
    styleUrls: ['./autocomplete-diagnostic.component.scss'],
    providers: [EPANDED_TEXTAREA_VALUE_ACCESSOR],
  })
  export class AutocompleteDiagnosticComponent implements ControlValueAccessor, OnInit, OnChanges {
    @Input() diagnosticId: number;
    @Output() onMyChange = new EventEmitter();
    @Input() disabled: boolean;
    @ViewChild('input') textarea;
  
    public diagnosticsOptions: any[];
  
    public onChange: (value: any) => void = () => {};
    public onTouched: (value: any) => void = () => {};
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;
    public filters: { key: string; value: string }[];
  
    public sel: any;
  
    constructor(
      private renderer: Renderer2,
      public diagnosticService: DiagnosticService
    ) {
      this.page = 1;
      this.per_page = 10;
    }
  
    public ngOnInit() {}
  
    ngOnChanges() {
      this.query = undefined;
      this.filters = [];
      this.filters.push({ key: 'activated-lk', value: '1' });
      if (this.diagnosticId) {
        this.filters.push({ key: 'code-lk', value: String(this.diagnosticId) });
        this.getDiagnostics(this.query);
      }
    }
  
    writeValue(value: any) {
      const div = this.textarea.nativeElement;
    }
  
    registerOnChange(fn: any) {
      this.onChange = fn;
    }
  
    registerOnTouched(fn: any) {
      this.onTouched = fn;
    }
  
    setDisabledState(isDisabled: boolean) {
      const div = this.textarea.nativeElement;
      const action = isDisabled ? 'addClass' : 'removeClass';
      this.renderer[action](div, 'disabled');
    }
  
    public change($event) {
      this.onMyChange.emit(this.sel);
      if (this.onChange) this.onChange(this.sel);
      if (this.onTouched) this.onTouched(this.sel);
    }
  
    public loadDiagnosticsLazy(event) {
      var str = event.query;
      var res = str.replace(/\s/g, '%');
      this.getDiagnostics(res);
    }
  
    getDiagnostics(query?: string) {
      this.diagnosticService
        .getDiagnosticLow(this.page, this.per_page, this.sort, query, this.filters)
        .toPromise()
        .then(
          (response) => {
            this.diagnosticsOptions = response.json().data;
            this.diagnosticsOptions.forEach((diagnosticOption) => {
              diagnosticOption.label = diagnosticOption.code + ' - ' + diagnosticOption.name;
            });
            if (this.diagnosticId) {
              this.diagnosticId = undefined;
              this.sel = this.diagnosticsOptions[0];
              this.filters = [];
              this.filters.push({ key: 'activated-lk', value: '1' });
            }
          },
          (error) => {
            this.diagnosticsOptions = [];
            this.diagnosticsOptions.push({ id: '', name: 'Error' });
          }
        );
    }
}
  


// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/custom-autocomplete/components/autocomplete-diagnostic/autocomplete-diagnostic.component.ts